import React from 'react';
import { FiPlus, FiMail } from 'react-icons/fi';

import {
  PageHeader,
  type PageHeaderAction,
} from '../../../../../components/PageHeader';

interface ChatListHeaderProps {
  onCreateChat: () => void;
  onEmailRemover: () => void;
}

export const ChatListHeader: React.FC<ChatListHeaderProps> = ({
  onCreateChat,
  onEmailRemover,
}) => {
  const pageActions: PageHeaderAction[] = [
    {
      label: 'Email Remover',
      icon: <FiMail size={16} />,
      onClick: onEmailRemover,
      color: 'danger',
      variant: 'bordered',
    },
    {
      label: 'Create Chat',
      icon: <FiPlus size={16} />,
      onClick: onCreateChat,
      color: 'primary',
    },
  ];

  return (
    <PageHeader
      title="Chats Management"
      description="Manage chat relationships between buyers and suppliers"
      actions={pageActions}
    />
  );
};
